import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { VISIT_DASHBOARD } from '../../../../utils/apollo/dashboards';
import {
  IDashboardVisitMutation,
  IDashboardVisitMutationVariables,
} from '../../../../utils/apollo/graphqlSchema';

const useVisitDashboardEffect = (dashboardBaseId: string) => {
  const [visitDashboardMutation] = useMutation<
    IDashboardVisitMutation,
    IDashboardVisitMutationVariables
  >(VISIT_DASHBOARD);

  useEffect(() => {
    if (dashboardBaseId) {
      visitDashboardMutation({
        variables: {
          input: {
            baseId: dashboardBaseId,
          },
        },
      });
    }
  }, [dashboardBaseId, visitDashboardMutation]);
};

export default useVisitDashboardEffect;
